<template>
  <div class="k3lkplh-v2-container" v-if="k3lData">
    <Edit v-show="$store.state.modalStore.showK3l" />
    <div class="k3lkplh-v2-wrapper k3lkplh-title">
      <div class="kkd-no">No</div>
      <div class="kkd-value">Nilai</div>
      <div class="kkd-desc">Keterangan</div>
      <div class="kkd-active-date kkd-active-date__kad-hover" @click="sortDate()">
        Tgl Efektif
        <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i><i class="fas fa-sort-numeric-up"
          v-show="!sortMode"></i>
      </div>
      <div class="kkd-end-date kkd-end-date__ked-hover" @click="sortDate2()">
        Tgl Berakhir
        <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i><i class="fas fa-sort-numeric-up"
          v-show="!sortMode"></i>
      </div>
      <div class="kkd-pic">PIC</div>
      <div class="kkd-last-review">Last Reviewer Name</div>
      <div class="kkd-last-review">Last Update</div>
      <div class="kkd-file">Attachment</div>
      <div class="kkd-view"></div>
      <div class="kkd-download"></div>
      <div class="kkd-lp"></div>
      <div class="kkd-edit"></div>
    </div>
    <div class="k3lkplh-v2-wrapper k3lkplh-content" v-for="(list, index) in k3lData" :key="index">
      <div class="kkd-no">
        <div>{{ index + 1 }}</div>
      </div>
      <div class="kkd-value">
        <div>{{ list.nilai }}</div>
      </div>
      <div class="kkd-desc">
        <div>{{ list.keterangan }}</div>
      </div>
      <div :class="`kkd-active-date ${list.activeDate < 0 ? `text-danger` : ''}`">
        <div>{{ formatDate(list.tanggal_efektif) }}</div>
      </div>
      <div class="kkd-end-date">
        <div>{{ formatDate(list.tanggal_berakhir) }}</div>
      </div>
      <div class="kkd-pic">
        <div>{{ list.pic }}</div>
      </div>
      <div class="kkd-last-review">
        <div>{{ list.last_reviewer }}</div>
      </div>
      <div class="kkd-last-review">
        <div>{{ list.update_by }}</div>
      </div>
      <div class="kkd-file col-elipsis all-column mr10">
        <div>
          {{
            list.attachment
              ? $linkConverter(list.attachment)
              : `K3L Penilaian ${$get(
                $store,
                'state.level1.profile.nama_vendor'
              )}`
          }}
        </div>
      </div>
      <!-- <div class="kkd-view" @click="viewDoc(list.attachment)" v-if="list.attachment">
        <i class="far fa-eye"></i>
      </div> -->
      <div class="kkd-download" @click="downloadDoc(list.attachment)"
        v-if="list.attachment && $get($store, 'state.permissions.47.allow')">
        <i class="fas fa-download"></i>
      </div>
      <div class="kkd-download" @click="checkDocument(list.request_id)"
        v-if="list.request_id && $get($store, 'state.permissions.47.allow')">
        <i class="far fa-eye"></i>
      </div>
      <div v-if="list.request_id" class="kkd-lp" @click="openLp(list.request_id)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          style="width:15px; height:15px">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
        </svg>
      </div>
      <div class="kkd-edit" @click="showModal(list.id)">
        <i class="far fa-edit" v-if="editingStatus && editingUser"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  components: {
    Edit: () => import('@/components/modal/k3l.vue'),
  },
  data() {
    return {
      sortMode: false,
      datas: [
        {
          id: 1,
          jenis: 'K3L',
          nilai: '55',
          desc: 'Low - C',
          activeDate: '14 Oct 2020',
          endDate: '14 Oct 2022',
          pic: 'Pratama',
          lastReviewer: 'Achmad',
          file: 'file.pdf',
        },
      ],
    }
  },
  computed: {
    k3lData() {
      return this.$store.state.level1.k3lData
    },
    editingStatus() {
      return this.$get(this.$store, 'state.editingStore.k3l_level_1.is_open', 0)
    },
    editingUser() {
      return (
        this.$get(this.$store, 'state.editingStore.k3l_level_1.user_id', '') ==
        this.$get(this.$store, 'state.userid', 0)
      )
    },
  },
  methods: {
    openLp(id) {
      const url = `${process.env.VUE_APP_LANDINGPAGE_URL}k3l-validation-hoc/${id}/${this.$store.state.userid}`
      window.open(url, '_blank')
    },
    sortDate() {
      this.sortMode = !this.sortMode
      let order_name = 'desc'

      if (!this.sortMode) {
        order_name = 'asc'
      }

      this.$store.commit('level1/SHORT_K3L_DATA', {
        column: 'tanggal_efektif',
        order_name,
      })
    },
    sortDate2() {
      this.sortMode = !this.sortMode
      let order_name = 'desc'

      if (!this.sortMode) {
        order_name = 'asc'
      }

      this.$store.commit('level1/SHORT_K3L_DATA', {
        column: 'tanggal_berakhir',
        order_name,
      })
    },
    showModal(id) {
      this.$store.commit('modalStore/SHOW_K3L')
      this.$store.dispatch('editStore/getK3lById', { id })
    },
    changeEditMode(id) {
      this.$store.dispatch('setEditMode', id)
    },
    viewDoc(link) {
      window.open(`${api}/file/${link}`)
    },
    downloadDoc(link) {
      if (link) {
        let linkUrl = `${api}/file/${link}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(link))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    checkDocument(id) {
      let routeData = this.$router.resolve({
        path: `/pdf/k3l-document/${id}/${this.$get(
          this.$store,
          'state.level1.profile.nama_vendor'
        )}`,
      })

      window.open(routeData.href, '_blank')
    },
  },
}
</script>
